import { SCAN_UI_CONTEXT_REGISTRY } from '../constants/scanUiContextRegistry.const';
import { type CreateScanContextOptions, type ScanContext } from '../types/scanContext.type';
import { resolveScanRouteContext } from './resolveScanRouteContext.util';

export const createScanContext = async ({
  barcodeValue,
  correlationId,
  getBarcodeContent,
  getIsConfiguredForScanToPrint = () => false,
  getUiContext = SCAN_UI_CONTEXT_REGISTRY.snapshot,
  pathname = window.location.pathname,
}: CreateScanContextOptions): Promise<ScanContext> => {
  const isConfiguredForScanToPrint = getIsConfiguredForScanToPrint();
  const route = resolveScanRouteContext(pathname);
  const ui = getUiContext();
  const barcodeContent = await getBarcodeContent({ barcodeValue, correlationId });

  return {
    ...(barcodeContent && { barcode_content: barcodeContent }),
    is_configured_for_scan_to_print: isConfiguredForScanToPrint,
    route,
    ui,
  };
};
